import { withStyles } from '@material-ui/core/styles';
import styles from './ItemInfo.styles';
import ItemInfo from './ItemInfo';

export default withStyles(styles)(ItemInfo);
